import React from 'react'

import ColumnType from '../ColumnType'
import Filters from '../../AllTasksTab/Filters'

import { useTaskCardState } from '../../../../../providers/TaskCardStateProvider'
import useSavedValue from '@SonarCX/hooks/useSavedValue'
import useStyles from './styles'

export const TASK_CARD_SEARCH_STORAGE_KEY = 'task_card_search'

const Controls: React.FC = () => {
  const { setExtraFilters } = useTaskCardState()

  const [tempSearch, setTempSearch] = useSavedValue({
    key: TASK_CARD_SEARCH_STORAGE_KEY,
    defaultValue: '""'
  })

  const classes = useStyles()

  const handleUpdate = React.useCallback(
    (url: string) => {
      setExtraFilters(url)
    },
    [setExtraFilters]
  )

  return (
    <div className={classes.root}>
      <ColumnType />

      <Filters
        onUpdate={handleUpdate}
        tempSearch={tempSearch}
        setTempSearch={setTempSearch}
        sort={[]}
        disableIncludeSubtasks
      />
    </div>
  )
}

export default Controls
